import React  from 'react';
import styled from 'styled-components';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Alert/index.css'
import {useTranslation} from "react-i18next";

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px;
    text-align: center;
`

export default function SSOConfigTestModal(props) {
    const dialogRef = props.modalRef;
    const {t} = useTranslation();
    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'            
                items={[<Item type='button' style={{backgroundColor: '#', width: '102px'}} onClick={props.onHandleDeactivate} >{t('confirm')}</Item>,
                <Item type='button' style={{backgroundColor: '#', width: '102px'}} onClick={props.onHandleCancel}>{t('cancel')}</Item>]}
                headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                footerStyle={{padding: '24px'}}
                cardStyle={{ marginBottom: '60px'}}
            >
                <ModalHeader>
                    {t('deactivateSSO')}
                </ModalHeader>
                <MainContent>
                    {t('messages.sso.msg9')}
                    {/*
                    Are you sure want to Deactivate SSO ?
                    SSO_CONSTANTS.
                    */}
                </MainContent>
            </Dialog>
        </>
    )
}